import { makeStyles } from "@mui/styles";
import { styled } from "@mui/material/styles";
import LinearProgress, { linearProgressClasses } from "@mui/material/LinearProgress";
import { Box, SxProps } from "@mui/material";
import progressComplete from "../../../assets/ProgressConfettiAnimation.json";
import Typography from "@mui/material/Typography";
import Lottie, { LottieRefCurrentProps } from "lottie-react";
import { useEffect, useRef, useState } from "react";

const useStyle = makeStyles((theme) => ({
  progressCompleteAnimation: {
    position: "absolute",
    top: "-27px",
    width: "64px",
    height: "64px",
    right: "-33px",
  },
  percentageStatus: {
    fontWeight: 600,
    fontSize: "1.25em",
    color: "#787676",
    letterSpacing: "0.15px",
  },
}));

const BorderLinearProgress = styled(LinearProgress)(({ theme }) => ({
  height: 12,
  width: "100%",
  borderRadius: 16,
  [`&.${linearProgressClasses.colorPrimary}`]: {
    backgroundColor: theme.palette.grey[theme.palette.mode === "light" ? 200 : 800],
  },
  [`& .${linearProgressClasses.bar}`]: {
    borderRadius: 16,
    backgroundColor: theme.palette.success.main,
    height: 12,
  },
}));

interface ModuleProgressIndicatorProps {
  percentage: number;
  moduleId: string;
  moduleName: string;
  style?: string;
  progressBarSx?: SxProps;
  percentageSx?: SxProps;
}

export const ModuleProgressIndicator = ({
  percentage,
  moduleName,
  style,
  progressBarSx,
  percentageSx,
}: ModuleProgressIndicatorProps) => {
  const classes = useStyle();
  const [progressCompleteAnimation, setProgressCompleteAnimation] = useState(false);
  const completeAnimationRef = useRef<LottieRefCurrentProps>(null);

  if (percentage === 100 && !progressCompleteAnimation) {
    setProgressCompleteAnimation(true);
  }
  useEffect(() => {
    if (progressCompleteAnimation && completeAnimationRef?.current) {
      completeAnimationRef?.current.play();
    }
  }, [progressCompleteAnimation, completeAnimationRef]);

  // useEffect(() => {
  //   if (!courseStructureCtx) {
  //     return;
  //   }
  //   if (!courseStructureCtx.courseTreeStructure) {
  //     return;
  //   }
  //   let module = courseStructureCtx.courseTreeStructure.getModule(moduleId);
  //   if (!module) {
  //     return;
  //   }
  //   module.upsertModuleProgress();
  // }, [courseStructureCtx, courseStructureCtx.courseTreeStructure, moduleId, percentage]);

  return (
    <>
      <Box sx={progressBarSx ? progressBarSx : { position: "relative", width: "342px" }}>
        <BorderLinearProgress
          variant="determinate"
          value={Math.round(percentage)}
          aria-label={`${moduleName} Progress`}
        />
        <Lottie
          lottieRef={completeAnimationRef}
          className={classes.progressCompleteAnimation}
          animationData={progressComplete}
          loop={false}
          autoplay={false}
        />
      </Box>
      <Typography
        variant="h5"
        component="span"
        className={style ? style : classes.percentageStatus}
        sx={percentageSx}>
        {percentage > 0 ? `${Math.round(percentage)}% practiced` : "Not started"}
      </Typography>
    </>
  );
};
